module.exports = __webpack_public_path__ + "pageHeader.e952f4c446093e1da715.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pageHeader.png
// module id = 691
// module chunks = 2